import { useEffect } from 'react';
import { PROMPT_PLACEHOLDER } from '../promptNode';

type Props = {
  prompt: string;
  onChange: (value: string) => void;
  onClose: () => void;
  locked?: boolean;
};

export default function OutcomePromptDrawer({ prompt, onChange, onClose, locked }: Props) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <aside
      data-testid="outcome-prompt-drawer"
      className="w-80 shrink-0 border-r border-border bg-bg flex flex-col overflow-hidden animate-slide-in"
      aria-label="Outcome prompt"
    >
      <div className="shrink-0 p-4 border-b border-border">
        <div className="flex items-start gap-2.5">
          <div className="w-8 h-8 rounded-md flex items-center justify-center shrink-0 bg-warning/20 text-warning">
            <i className="ri-flag-2-fill text-base" />
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="text-sm font-semibold text-textp">Outcome</h2>
            <div className="text-[11px] text-texts mt-0.5">Full prompt</div>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close outcome prompt"
            className="shrink-0 w-7 h-7 rounded-md text-texts hover:text-textp hover:bg-surface flex items-center justify-center"
          >
            <i className="ri-close-line text-base" />
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-hidden p-4">
        <textarea
          data-testid="outcome-prompt-drawer-input"
          value={prompt}
          onChange={(e) => onChange(e.target.value)}
          placeholder={PROMPT_PLACEHOLDER}
          readOnly={locked}
          className="w-full h-full min-h-[240px] bg-surface/60 border border-border rounded-md px-3 py-2.5 text-[13px] leading-relaxed text-textp placeholder:text-texts outline-none focus:border-warning resize-none disabled:opacity-60"
        />
      </div>

      <div className="shrink-0 px-4 py-2.5 border-t border-border text-[11px] text-texts flex items-center gap-1.5">
        <i className="ri-information-line" />
        The graph node stays compact; edit the outcome here
      </div>
    </aside>
  );
}
